<template>
	<div :class="{
			'dy-checkbox'	: true, 
			'checked'		: value==1, 
			'indeterminate'	: value==2, 
			disable			: disable
		}" 
		:style="{
			'--backgroundColor'	: backgroundColor,
			'--borderColor'		: borderColor
		}"
		@click="click">
		<slot></slot>
	</div>
</template>

<script>
	export default {
		name:"dy-checkbox",
		props:{
			modelValue:{
				type:[Boolean,Number],
				default:false,
			},
			backgroundColor:{
				type:String,
				default:'#191919',
			},
			borderColor:{
				type:String,
				default:'#efefef',
			},
			radio:{
				type:Boolean,
				default:false,
			},
			disable:{
				type:Boolean,
				default:false,
			},
			unclick:{
				type:Boolean,
				default:false,
			}
		},
		data() {
			return {
				value:this.modelValue,
			};
		},
		watch:{
			modelValue(val){
				this.value = val;
			},
			value(val){
				this.$emit('update:modelValue', val);
				this.$emit('change', val);
			}
		},
		methods:{
			click(){
				if(this.disable||this.unclick) return;
				this.value = !this.value || this.radio;
			}
		}
	}
</script>

<style>
	.dy-checkbox{
		position: relative;
		font-size:14px;
		padding-left:20px;
		/* border:1px solid #343434; */
		margin-right:5px;
		border-radius:3px;
		white-space: nowrap;
	}
	.dy-checkbox:after{
		content:' ';
		font-family:iconfont;
		position: absolute;
		width:16px;
		height:16px;
		left:0px;
		top:50%;
		margin-top:-8px;
		box-sizing: border-box;
		font-size:14px;
		line-height:16px;
		text-align: center;
		background-color:var(--backgroundColor);
		/* border:1px solid var(--borderColor); */
		border-radius:3px;
	}
	
	.dy-checkbox.checked:after{
		content: '\ea84';
		background:linear-gradient(-45deg,#7d65f8,#3999ca);
		color:#fff;
	}
	
	.dy-checkbox.indeterminate:after{
		content: '\ea84';
		background:linear-gradient(-45deg,#7d65f8,#3999ca);
		color:#fff;
	}
	
	.dy-checkbox.disable,
	.dy-checkbox.disable.checked,
	.dy-checkbox.disable.indeterminate,
	.dy-checkbox.disable:after,
	.dy-checkbox.disable.checked:after,
	.dy-checkbox.disable.indeterminate:after{
		background-color: #F8F8F8 !important;
	}
</style>